import React from 'react'
import { StaticImage } from 'gatsby-plugin-image'
import Layout from '../../../layouts'
import LargeHero from '../../../components/elements/largeHero'
import { Body, SizedText, Canon } from '../../../components/elements/typography'
import Grid from '../../../components/elements/grid'
import ExternalLink from '../../../components/elements/externalLink'
import SEO from '../../../components/elements/seo'

import PoliciesMenu from "../../../components/molocules/menus/policiesMenu"

const TopBox = ({title, width, children}) => (
  <div css={{
    backgroundColor: `#fff`,
    //textAlign: `justify`,
    hyphens: `auto`,
    padding: `2rem 1.5rem 2rem 2rem`,
    '& p': {
      fontWeight: `600`,
      '& span': {
        fontWeight: `400`
      }
    }, 
  }}>
    <SizedText as="h2" smallSize="2.281" largeSize="1.802" css={{paddingBottom: `1rem`}}>{title}</SizedText>
    {children}
  </div>
)

const FairLendingPolicyPage = () => {
  return (
    <Layout isSubMenuOpen={true} openAccountLink={true}>

      <SEO
        title="Fair and Responsible Lending | TCB Trust Center"
        description="TCB is committed to providing credit opportunities in the communities in which we conduct business. We recognize our responsibility for ensuring members of these communities receive equal 
        access to our products and services, which is why it is the policy of The Claxton Bank to comply both to the letter and spirit of fair and responsible lending laws."
        location="/about/policies/fair-lending-policy"
        ogImg='/images/social-graph/the-claxton-bank.jpg'
      />  

      <LargeHero.Container
        padding="3rem 0 4rem 0"
        background={{
          //backgroundColor: `#b2a08a`,
          backgroundImage: `url(/images/background-deltas.jpg)`, 
          backgroundRepeat: `no-repeat`, 
          backgroundAttachment: `scroll`, 
          backgroundPosition: `top left`, 
          backgroundSize: `cover`,
        }}
        breadcrumbLinks={[
          { path: "/", text: "Home" },
          { path: "/about/", text: "About Us" },
          { path: "/about/policies/", text: "Policies" },
          { path: "/about/policies/fair-lending-policy", text: "Fair Lending Policy" }
        ]}
        styles={{
          paddingBottom: `5rem`,
          overflow: `hidden`,
          '.breadcrumbs, .breadcrumbs [aria-current="page"]': {color: `#fff`},
          '.heroContent': { paddingBottom: `3rem`},
          '@media (min-width: 680px)': {
            '.heroContent': { width: `calc(72% - 1rem)`, marginBottom: `0`},
            '.heroImage': { width: `calc(40% - 1rem) !important`,},
          }
        }}
      >
        <LargeHero.Content styles={{paddingTop: `1rem`, color: `#fff`}}>
          <LargeHero.Eyebrow text="Policies & Disclosures" styles={{borderColor: `#fff !important`}}/>
          <h1 css={{fontFamily: `Proxima-nova`, textTransform: `uppercase`,  'span': {display: `block`, lineHeight: `1`, padding: `0.5rem 0`}}}>
            <SizedText as="span" smallSize="2.281" largeSize="4.624">FAIR AND RESPONSIBLE LENDING</SizedText>
          </h1>
        </LargeHero.Content>
        <LargeHero.Image >
          <StaticImage 
              css={{
                '@media (min-width: 680px)': { display: 'none !important' }, 
                '@media (min-width: 1300px)': { display: 'block !important' } 
              }} 
              src="../../../images/policies.png" 
              alt=""
            />
            <StaticImage 
              css={{
                display: `none !important`,  
                '@media (min-width: 680px)': { display: 'block !important' }, 
                '@media (min-width: 1300px)': { display: 'none !important' } 
              }} 
              src="../../../images/policies_cropped.png" 
              alt=""
            />
        </LargeHero.Image>
      </LargeHero.Container>

      <Grid.FullWidthSection>
        <Grid.Block start={[2,2,2,2,2,2,3]} span={[12,12,12,12,8,8,7]} css={{
          paddingBottom: `4rem`,
          'p': {textAlign: `justify`, color: "#707070"},
          'h1': {color: `#1d449e`},
          'h2': { marginTop: `2rem`, color: `#2980b9`, fontFamily: `proxima-nova`}
        }}>
          <SizedText as="p" smallSize="1" largeSize="1.125" css={{padding: `4rem 0`, lineHeight: '1.5 !important'}}>
              The Claxton Bank (“TCB”) is committed to providing credit opportunities in the communities in which we conduct business. We recognize our responsibility for ensuring members 
              of these communities receive equal access to our products and services, which is why it is the policy of The Claxton Bank to comply both to the letter and spirit of fair and 
              responsible lending laws. TCB’s fair treatment of current and potential customers is a vital part of our overall commitment to maintaining the highest standard of corporate 
              responsibility. This extends to every aspect of a credit transaction, including but not limited to, advertisement, pre-application inquiries, loan disbursements, and loan 
              servicing. It is the Bank’s policy to treat all consumers consistently and fairly. Our employees will offer assistance, encouragement and service in a fair, equitable, and 
              consistent manner. We will also communicate our fair lending policy to all of our brokers and correspondents.
            </SizedText>


            <Canon>Fair Lending Laws</Canon>
            <Body>
              Fair lending laws in the United States require equitable treatment of all credit applicants without regard to race, sex, gender identity, sexual orientation, color, national 
              origin, religion, age, marital status, disability, familial status, the fact that all or part of the applicant’s income derives from public assistance programs, or to the fact 
              that the applicant has in good faith exercised any right under the Consumer Credit Protection Act. Denying any person equal access to credit and economic opportunities is immoral 
              and will not be tolerated in our company. We will help meet the credit needs of the communities in which we operate, including low-income and moderate-income neighborhoods.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Equal Credit Opportunity Act (ECOA)
            </SizedText>
            <Body>
              Under the Equal Credit Opportunity Act (ECOA), it is illegal to discriminate in any credit transaction on the basis of race, color, religion, national origin, sex, gender identity, marital status, 
              age (provided the applicant has the capacity to contract), applicant’s receipt of public assistance income, and/or the applicant’s exercise of any right under the Consumer Credit 
              Protection Act, affects every phase of the lending process. The provisions of the ECOA make it illegal to discourage an applicant, decline a request for, or terminate a loan based 
              on any of the factors listed above.
            </Body>

            {/** <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Home Mortgage Disclosure Act (HMDA)
            </SizedText>
            <Body>
              The Home Mortgage Disclosure Act (HMDA) requires financial institutions to report information about certain loans they originate or purchase, including income, race, ethnicity, gender, 
              and geographical area. HMDA was created to provide federal regulators and the public with the Bank’s loan data to assist in determining that the Bank is serving the housing needs of our 
              community and to ensure there are no possible discriminatory lending patterns.
      </Body>**/}

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Fair Housing Act (FHA)
            </SizedText>
            <Body>
              The Fair Housing Act prohibits discrimination in the sale, rental, and financing of property based on disability, familial status, gender, national origin, race, religion, or sexual orientation 
              and ensures the Bank’s adherence to the provisions prohibiting discriminatory practices against applicants applying for real estate loans for the purchase, construction, improvement, repair, or 
              maintenance of a dwelling, or loans secured by a dwelling.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Americans With Disabilities Act (ADA)
            </SizedText>
            <Body>
              The Americans with Disabilities Act (ADA) prohibits discrimination against qualified individuals with disabilities. It assures that protected individuals have equal access to goods and services offered by private businesses.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Civil Rights Act of 1886
            </SizedText>
            <Body>
              This law guarantees equal rights to purchase real estate and personal property to all people, regardless of race.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Community Reinvestment Act
            </SizedText>
            <Body>
              The Community Reinvestment Act ensures that the Bank is meeting the credit needs of the communities which it serves within its assessment area.
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Fair Credit Reporting Act
            </SizedText>
            <Body>
              Under the Fair Credit Reporting Act, it is the Bank’s policy to prevent undue invasion of a consumer’s right to privacy in the process of collecting information and disseminating credit reports.
            </Body>

            <Canon styleOverrides={{paddingTop: `4rem`}}>Fair Lending Regulatory and Enforcement Agencies</Canon>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Our Regulatory Agencies
            </SizedText>
            <Body>
              Regulatory agencies have a broad range of powers in evaluating the compliance of lenders. The Claxton Bank undergoes routine examinations to ensure that our policies and procedures are in compliance 
              with our own internal policies, industry standards and best practices, and state and federal regulations. Our fair lending regulatory agencies include the:
              <ul>
                <li><ExternalLink to="https://www.consumerfinance.gov/">Consumer Financial Protection Bureau (CFPB)</ExternalLink></li>
                <li><ExternalLink to="https://www.federalreserve.gov/">Federal Reserve Board (FRB)</ExternalLink></li>
                <li><ExternalLink to="https://www.fdic.gov/">Federal Deposit Insurance Corporation (FDIC)</ExternalLink></li>
                <li><ExternalLink to="https://www.ftc.gov/">Federal Trade Commission (FTC)</ExternalLink></li>
                <li><ExternalLink to="https://dbf.georgia.gov/">Georgia Department of Banking and Finance (DBF)</ExternalLink></li>
              </ul>
            </Body>

            <SizedText as="h2" smallSize="1.424" largeSize="1.802" css={{paddingBottom: `1rem`}}>
              Enforcement Agencies
            </SizedText>
            <Body>
              Enforcement agencies investigate alleged Fair Lending violations, and include the:
              <ul>
                <li><ExternalLink to="https://www.justice.gov/">Department of Justice (DOJ)</ExternalLink></li>
                <li><ExternalLink to="https://www.hud.gov/">Department of Housing and Urban Development (HUD)</ExternalLink></li>
              </ul>
            </Body>
        </Grid.Block>
        <Grid.Block start={[2,2,2,2,10,10]} span={[12,12,12,12,4,3]}
          css={{ 
            margin: `4rem 0`,
        }}>
          
          <PoliciesMenu />



        {/*   <div css={{marginTop: `6rem`}}>
            <SizedText as="h2" smallSize="2.281" largeSize="1.802" css={{ padding: `0 1rem 0.5rem`, fontFamily: `proxima-nova`, borderBottom: `2px solid #000`}}>
              Credit Resources
            </SizedText>

            <div css={{
              border: `1px solid #000`,
              backgroundColor: `#fff`,
              height: `12rem`,
              margin:`2rem 0`,
            }}></div>

            <div css={{
              border: `1px solid #000`,
              backgroundColor: `#fff`,
              height: `12rem`,
              margin:`2rem 0`,
            }}></div>

            <div css={{
              border: `1px solid #000`,
              backgroundColor: `#fff`,
              height: `12rem`,
              margin:`2rem 0`,
            }}></div>

            <div css={{
              border: `1px solid #000`,
              backgroundColor: `#fff`,
              height: `12rem`,
              margin:`2rem 0`,
            }}></div>
          </div> */}
        </Grid.Block>
      </Grid.FullWidthSection>
    </Layout> 
  )
}

export default FairLendingPolicyPage
